import Model from './BaseModel';
import TrackBetType from './TrackBetType';
import TrackClassification from './TrackClassification';
import TrackFees from './TrackFees';

export default class Track extends Model {
	resourceName() {
		return 'tracks';
	}

	fields() {
		return ['country', 'name', 'state'];
	}

	relationships() {
		return {
			bet_types: new TrackBetType(),
			classifications: new TrackClassification(),
			fees: new TrackFees()
		};
	}
}
